<template>
  <b-navbar :class="navBarClass" id="navBar" type="light" toggleable="sm" variant="light">
    <b-navbar-brand>
      <b-img
          src="https://firebasestorage.googleapis.com/v0/b/la-llucana.appspot.com/o/Logotip_Plataforma_Negatiu.png?alt=media&token=584b349a-646d-465b-9f92-7010130a9040"
          class="img" alt="Logo Violencia de Genere">
      </b-img>
    </b-navbar-brand>
    <b-container>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="text-center mx-auto">
          <b-nav-item v-on:click="changeLocale('en')" id="en"><a
              style="cursor: pointer; text-align: center">{{ $t('EnLanguage') }}</a>
          </b-nav-item>
          <b-nav-item v-on:click="changeLocale('es')" id="es"><a>{{ $t('EsLanguage') }}</a></b-nav-item>
          <b-nav-item v-on:click="changeLocale('cat')" id="cat"><a>{{ $t('CatLanguage') }}</a></b-nav-item>
        </b-navbar-nav>

        <!--Right aligned nav items -->
        <b-navbar-nav class="ml-auto" v-if="$route.path != '/login' && $route.path != '/register'">
          <b-nav-form>
            <b-icon-box-arrow-in-left v-on:click="logOut" 
                                      style="cursor: pointer" 
                                      size="md" scale="1.25"
                                      class="my-2 my-sm-0">
            </b-icon-box-arrow-in-left>
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>
<script>
import app from "@/firebaseConfig/config";
import 'firebase/database'
import Cryptr from "crypto-js";
import {mapState} from "vuex";
import apiService from "@/service/service";

export default {
  name: "NavBar",
  data() {
    return {
      languages: [
        {flag: 'us', language: 'en'},
        {flag: 'es', language: 'es'},
        {flag: 'cat', language: 'cat'}
      ],
      usersRef: '',
      isUpdated: false,


    }
  },
  computed: {
    ...mapState(['navBarClass'])
  },
  methods: {
    /**
     * Function that log out user from the page
     */
    logOut() {
      this.$store.commit('updateIsLoading', true)
      localStorage.clear()
      sessionStorage.clear()
      this.onUserDisconnect()
      this.deleteAllCookies()
      this.deleteCookie('UserLogged', '/player')
      this.deleteCookie('code', '/')
      this.deleteCookie('code', '/')
      this.deleteCookie('isChat', '/')
      this.deleteCookie('email', '/')
      this.deleteCookie('userRole', '/')
      this.deleteCookie('areQuestions', '/player')
      this.deleteCookie('name', '/')


    },
    /**
     * Change language of the page
     * @param locale
     */
    changeLocale(locale) {
      this.$i18n.locale = locale;
      for (const language of this.languages) {
        locale === language.language ? document.getElementById(language.language).classList.add('active') : document.getElementById(language.language).classList.remove('active')
      }
    },
    /**
     * Function for set cookie passed by params
     * @param cookieName
     * @param cookieValue
     * @param encrypted
     */
    setCookie(cookieName, cookieValue, encrypted) {
      const now = new Date()
      const time = now.getTime()
      const expireTime = time + 1000 * 36000
      now.setTime(expireTime)
      encrypted ? document.cookie = cookieName + "=" + Cryptr.AES.encrypt(cookieValue, 'secret key 1234').toString() + "; expires=" + now.toUTCString() : document.cookie = cookieName + "=" + cookieValue + "; expires=" + now.toUTCString()


    },
    /**
     * Get value of cookie passed by param
     * @param cname
     * @returns {string}
     */
    getCookie(cname) {
      //function that passes the key of the cookie to obtain the value
      const name = cname + "=";
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    /**
     * Delete cookie passed by param
     * @param name
     */
    deleteCookie(name) {
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },
    /**
     * Disconnects user from real time database and sign out user from firebase auth
     */
    async onUserDisconnect() {
      if (!this.isUpdated) {
        this.isUpdated = true
        const cookie = this.getCookie('email')
        const code = this.getCookie('code').toLowerCase().replace(/\s/g, "")
        const data = {email: cookie, code: code}
        try {
          const accessToken = await app.auth().currentUser.getIdToken()
          await apiService.logOutUser(accessToken, data)
          await app.auth().signOut()
          localStorage.clear()
          this.isUpdated = false
          await this.$router.push({path: `/login`})
          this.$store.commit('updateIsLoading', false)
        } catch (e) {
          console.log(e.message)
        }
      }
    },
    deleteAllCookies() {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      }
    }
  },
  created() {
    const code = this.getCookie('code').toLowerCase().replace(/\s/g, "")
    this.usersRef = app.database().ref(`lallucana/${code}/users`)
  },
  mounted() {
    //Change default  language to catalan
    const lang = window.navigator.language
    if (lang.includes('es')) {
      this.$i18n.locale = 'es'
    } else if (lang.includes('cat')) {
      this.$i18n.locale = 'cat'
    } else {
      this.$i18n.locale = 'en'
    }
    for (const language of this.languages) {
      this.$i18n.locale === language.language ? document.getElementById(language.language).classList.add('active') : document.getElementById(language.language).classList.remove('active')
    }
  }
}
</script>

<style scoped>
.img {
  width: 110px;
}

.navDisplayNone {
  display: none;
}
</style>
